import { render, staticRenderFns } from "./ZRPanelGroup.vue?vue&type=template&id=78b26ee2&scoped=true"
import script from "./ZRPanelGroup.vue?vue&type=script&lang=js"
export * from "./ZRPanelGroup.vue?vue&type=script&lang=js"
import style0 from "./ZRPanelGroup.vue?vue&type=style&index=0&id=78b26ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b26ee2",
  null
  
)

export default component.exports